export default class {
    _id;
    _measurement;
    _ndsRate;
    _ndsValue;
    _price;
    _product;
    _quantity;
    _total;
    _catalogCode;
    _totalWithNds;
    _customerCode;
    _orderItem;

    constructor() {
        this._id = null
        this._product = ''
        this._measurement = null
        this._ndsRate = null
        this._ndsValue = 0
        this._price = 0
        this._quantity = 0
        this._total = 0
        this._totalWithNds = 0
        this._customerCode = null;
        this._catalogCode = null
        this._orderItem = null
    }

    get id() {
        return this._id
    }

    set id(value) {
        this._id = value
    }

    get measurement() {
        return this._measurement
    }

    set measurement(value) {
        this._measurement = value
    }

    get ndsRate() {
        return this._ndsRate
    }

    set ndsRate(value) {
        this._ndsRate = value
    }

    get ndsValue() {
        return this._ndsValue
    }

    set ndsValue(value) {
        this._ndsValue = value
    }

    get price() {
        return this._price
    }

    set price(value) {
        this._price = value
    }

    get product() {
        return this._product
    }

    set product(value) {
        this._product = value
    }

    get quantity() {
        return this._quantity
    }

    set quantity(value) {
        this._quantity = value
    }

    get total() {
        return this._total
    }

    set total(value) {
        this._total = value
    }

    get totalWithNds() {
        return this._totalWithNds
    }

    set totalWithNds(value) {
        this._totalWithNds = value
    }

    get customerCode() {
        return this._customerCode
    }

    set customerCode(value) {
        this._customerCode = value
    }

    get catalogCode() {
        return this._catalogCode
    }

    set catalogCode(value) {
        this._catalogCode = value
    }

    get orderItem() {
        return this._orderItem
    }

    set orderItem(value) {
        this._orderItem = value
    }
}